import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './styles.css';
import { IstmasApp } from './IstmasApp';

ReactDOM.render(
    <IstmasApp />,
  document.getElementById('root')
);